import { useEffect } from "react";

const upsertMeta = (selector, attrs) => {
  let node = document.head.querySelector(selector);
  if (!node) {
    node = document.createElement(attrs.tag || "meta");
    document.head.appendChild(node);
  }
  Object.entries(attrs).forEach(([key, value]) => key !== "tag" && node.setAttribute(key, value));
};

export default function usePageMetadata({ title, description, path, image = "/og-image.png", noindex = false, jsonLd = [] }) {
  useEffect(() => {
    const origin = "https://trubeaute.com";
    const url = `${origin}${path}`;
    document.title = title;
    upsertMeta('meta[name="description"]', { name: "description", content: description });
    upsertMeta('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, nofollow" : "index, follow, max-image-preview:large" });
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: title });
    upsertMeta('meta[property="og:description"]', { property: "og:description", content: description });
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: url });
    upsertMeta('meta[property="og:image"]', { property: "og:image", content: `${origin}${image}` });
    upsertMeta('meta[property="og:locale"]', { property: "og:locale", content: "en_US" });
    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    upsertMeta('meta[name="twitter:image"]', { name: "twitter:image", content: `${origin}${image}` });
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = url;
    document.querySelectorAll('script[data-public-education-jsonld]').forEach((node) => node.remove());
    jsonLd.forEach((data) => {
      const script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.publicEducationJsonld = "true";
      script.text = JSON.stringify(data);
      document.head.appendChild(script);
    });
  }, [title, description, path, image, noindex, jsonLd]);
}
